module.exports = __webpack_public_path__ + "static/media/suttipong-surak-22764-unsplash.972374cf.jpg";